import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { Icon, Loader, InfoLabel, DateRangeField, FieldValue, ModalNextContext } from '@jutro/components';
import { AccountBillingDetailsService } from 'gw-capability-billing';
import { UsersProfileDetailsService } from 'gw-capability-profileinfo';
import { PolicyService } from 'gw-capability-policy';
import { AMPSubmissionDraftService } from 'gw-capability-quoteandbind';
import { DocumentService } from 'gw-capability-policydocument';
import { Currency as CurrencyField, LoaderExt } from 'gw-components-platform-react';
import { getNormalizedLOBName, isCapabilityEnabled } from '@xengage/gw-portals-config-js';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { LobIconUtil, LocalDateUtil } from '@xengage/gw-portals-util-js';
import { generateURL } from '@xengage/gw-portals-url-js';
import { useTranslator } from '@jutro/locale';
import moment from 'moment';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

import { AccountService } from 'gw-capability-gateway-policy';
import styles from './PoliciesPage.module.scss';
import metadata from './PoliciesPage.metadata.json5';
import messages from './PoliciesPage.messages';
import { publish, subscribe } from '@jutro/events';
import  usecpmiAnalytics from '../../hooks/usecpmiAnalytics'
import useGoogleAnalytics from '../../hooks/useGoogleAnalytics';
import { AccountDropDownValues } from '../cpmi_SelectAccountDropDown';

import { Link } from '@jutro/router';

const getCellType = (rowData) => {
    const activePeriod = _.first(rowData.periods);
    const lineOfBusinessName = rowData.lineOfBusinessName==='Workers\' Comp Line (v7)'?'Workers\' Compensation':rowData.lineOfBusinessName?.split(' (v7)')[0]
    return <FieldValue value={lineOfBusinessName}/>
};

const isPolicyActive = (rowData) => {
    const currentRenewed = !_.isEmpty(rowData);
    return new Date(rowData.effective).getTime() < new Date().getTime() && !currentRenewed;
};

const shouldRenewalNotificationShow = (accountPolicyData) => {
    return accountPolicyData.some((policy) => policy.length > 1);
};



const getCellStatus = (rowData) => {
    const status = rowData.displayStatus
    const statuscolor = status === 'Canceled'?'red':""
    return <FieldValue  style={{color:statuscolor}} value={status}
    />
};

// const getCellPolicy = (rowData) => {
//     const periodWithIDCard = rowData.termPublicId;

//       publish('JUTRO_TOPICS.BUTTON_CLICKED', {
//         path: '/account-policy-details',
//         title: 'View Policy Details'
//     });

//     return (
//         <Link
//             className={styles.link}
//             to={{
//                 pathname: `/account-policy-details/${rowData.policyNumber}`,
//                 productCode: rowData.lineOfBusinessCode,
//                 state:{term:rowData.termNumber,
//                     policyNumber:rowData.policyNumber,
//                     isODSPolicy:rowData.isODSPolicy,
//                     effective:rowData.effective,
//                     expiration:rowData.expiration,

//                 },
//                 idCard: periodWithIDCard ? {
//                     idCardSessionID: _.get(periodWithIDCard, 'idCardSessionID'),
//                     idCardPublicID: _.get(periodWithIDCard, 'idCardPublicID')
//                 } : null
//             }}
//         >
//             {rowData.policyNumber}
//         </Link>
//     );
// };

const getCellEffective = (rowData, rowIndex) => {
   
    const startDate = moment(rowData.effective).format('MM/DD/YYYY');
    const endDate = moment(rowData.expiration).format('MM/DD/YYYY');
    
    const policyeffectivePeriod =`${startDate} - ${endDate}`;
    return (
        <FieldValue
            
            id={`effectiveDate_${rowIndex}`}
            value={policyeffectivePeriod}
            hideLabel
            readOnly
        />
    );
   
    
};

const getCellClaim = (rowData) => {

    const redirectPath = {
        pathname: '/fnol-select-policy',
        state: {
            policyNumber: rowData.policyNumber,
            redirectPath: '/home',
            claimData: { lossDate: new Date() }
        }
    };
    return (
        <Link to={redirectPath} className={styles.link}>
            {messages.fileClaim}
        </Link>
    );
};

const getCellPremium = (rowData, rowIndex) => {
    return (
        <CurrencyField
            id={`premium_${rowIndex}`}
            value={rowData.premium}
            dataType="object"
            readOnly
            hideLabel
        />
    );
};

const getCellLocation = (rowData) => {
    const states = rowData.states.length>0?(rowData.states.length>1?rowData.states.join(', '):rowData.states[0]):"-"
    return (
        <FieldValue
            value={states}
            dataType="object"
            readOnly
            hideLabel
        />
       
    );
};

const { capabilitiesConfig } = appConfig;

function PoliciesPage(props) {
    const {
        history: {
            location: { state }
        },history,
    }=props;
    const translator = useTranslator();
    const [accountBillingData, setAccountBillingData] = useState([]);
    const [accountPolicyData, setAccountPolicyData] = useState([]);
    const { authHeader } = useAuthentication();
    const [accountData, setAccountData] = useState([]);
    const [isLoading, setLoadingState] = useState(false);
    

    const [trackPageView,trackEvent] = usecpmiAnalytics();
    const [trackGAPageView] = useGoogleAnalytics();
    const[policyAccountDropdown,setPolicyAccountDropdown]=useState();
    const [filteredDatasetVal, setFilteredDatasetVal] =useState([]);

    useEffect(() => {
        trackPageView("Policies","/policiespage")
        setLoadingState(true);
        let billingPromise = Promise.resolve([]);
        if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' })) {
            billingPromise = AccountBillingDetailsService.getAccountBillingSummary(authHeader);
        }
        Promise.all([billingPromise.then(setAccountBillingData),
            // PolicyService.getAllAvailableAccountPolicySummaries_Ext(authHeader).then((setAccountPolicyData)),
            PolicyService.getAllAvailableAccountPolicySummaries_Ext(authHeader).then((result)=>{
                result.sort((a, b)=> {
                    const createSortKey = (p)=> { return `${p.effective}  ${p.expiration}`}
                    return createSortKey(a) > createSortKey(b) ? -1 : 1
                })
                setAccountPolicyData(result);
            }),
            UsersProfileDetailsService.getAccountsContactSummaries(authHeader).then(setAccountData)
        ]).finally(() => {
            setLoadingState(false);
        });
        // disable re render
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
       
        trackGAPageView("/policiespage","Policies")
    },[])

    const showRenewalNotificationShow =(accountPolicyData) => {
    return accountPolicyData.filter((statusData)=>statusData.accountNumber===policyAccountDropdown).some((policy) => policy.displayStatus === 'Pending Cancellation');
    };

    // useEffect(()=>{
    //     filterDropdownData();
    // },[filterDropdownData])

    const viewPolicyDetail = ((rowData) => {
        
        const periodWithIDCard = rowData.termPublicId;
        return history.push({
            pathname: `/account-policy-details/${rowData.policyNumber}`,
            productCode: rowData.lineOfBusinessCode,
            state:{term:rowData.termNumber,
                policyNumber:rowData.policyNumber,
                isODSPolicy:rowData.isODSPolicy,
                effective:LocalDateUtil.toMidnightDate(rowData.effective),//rowData.effective,
                expiration:LocalDateUtil.toMidnightDate(rowData.expiration),
    
            },
            idCard: periodWithIDCard ? {
                idCardSessionID: _.get(periodWithIDCard, 'idCardSessionID'),
                idCardPublicID: _.get(periodWithIDCard, 'idCardPublicID')
            } : null,
        });
    })
    const getCellPolicy = (rowData) => {
        const periodWithIDCard = rowData.termPublicId;
    
        //   publish('JUTRO_TOPICS.BUTTON_CLICKED', {
        //     path: '/account-policy-details',
        //     title: 'View Policy Details'
        // });
        const data = {term:rowData.termNumber,
            policyNumber:rowData.policyNumber,
            isODSPolicy:rowData.isODSPolicy,
            effective:LocalDateUtil.toMidnightDate(rowData.effective),
            expiration:LocalDateUtil.toMidnightDate(rowData.expiration),
            
        }
        return (
            <Link
                className={styles.link}
                style={{display:"block"}}
                onClick={() =>  trackEvent("View Policy Details","/account-policy-details")}
                to={{
                    pathname: `/account-policy-details/${rowData.policyNumber}`,
                    productCode: rowData.lineOfBusinessCode,
                    state:{term:rowData.termNumber,
                        policyNumber:rowData.policyNumber,
                        isODSPolicy:rowData.isODSPolicy,
                        effective:LocalDateUtil.toMidnightDate(rowData.effective),
                        expiration:LocalDateUtil.toMidnightDate(rowData.expiration),},
                    idCard: periodWithIDCard ? {
                        idCardSessionID: _.get(periodWithIDCard, 'idCardSessionID'),
                        idCardPublicID: _.get(periodWithIDCard, 'idCardPublicID')
                    } : null
                }}
            >
                {rowData.policyNumber}
            </Link>
        );
    };

    const aggregateBilling = useCallback((invoices) => {
        if (invoices.length === 0) {
            return null;
        }

        let total = 0;
        let due = new Date(invoices[0].dueDate);

        _.each(invoices, (invoice) => {
            total += invoice.amountDue.amount;
            const newDue = new Date(invoice.dueDate);
            if (newDue.getTime() < due.getTime()) {
                due = newDue;
            }
        });

        return {
            amountDue: {
                amount: total,
                currency: invoices[0].amountDue.currency
            },
            earliestDue: due
        };
    }, []);

    const getMyBalanceOverDueAndCurrentData = useCallback(
        (invoiceStatus) => {
            if (accountBillingData.activeInvoices) {
                const invoices = accountBillingData.activeInvoices;
                return aggregateBilling(
                    invoices.filter((invoice) => invoice.invoiceStatus === invoiceStatus)
                );
            }
            return null;
        },
        [accountBillingData.activeInvoices]
    );

    const getBalanceData = useCallback(() => {
        const overdue = getMyBalanceOverDueAndCurrentData('due');
        const current = getMyBalanceOverDueAndCurrentData('billed');
        if (overdue && current) {
            return {
                amount: current.amountDue.amount + overdue.amountDue.amount,
                currency: current.amountDue.currency
            };
        }
        if (overdue || current) {
            return (overdue || current).amountDue;
        }
        return null;
    }, []);

    const readValue = useCallback(
        (id, path) => {
            if (path === 'balanceAmount') {
                return getBalanceData();
            }
            if (path === 'overDueAmount') {
                return _.get(getMyBalanceOverDueAndCurrentData('due'), 'amountDue');
            }
            if (path === 'currentAmount') {
                return _.get(getMyBalanceOverDueAndCurrentData('billed'), 'amountDue');
            }
            if (path === 'dueDate') {
                return _.get(getMyBalanceOverDueAndCurrentData('due'), 'earliestDue');
            }
            return _.get(accountBillingData, path);
        },
        [accountBillingData]
    );

    const automatedPaymentURL = useMemo(() => {
        const billingID = _.get(accountBillingData, 'manualPayPaymentGroups[0]');

        if (!billingID) {
            return undefined;
        }
        return `billing-summary/${billingID}`;
    }, [accountBillingData]);

    const firstAccountSummaryDefined = useMemo(() => {
        return accountData.length <= 1 && !_.isEmpty(accountData);
    }, [accountData]);

    const mailToTrigger = useCallback((event, email) => {
        event.preventDefault();
        window.location = `mailto:${email}`;
    }, []);

    const claimCapabilityCheck = useMemo(() => {
        return isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'fnol' });
    }, []);

    const onQuoteQuickLinkClick = useCallback(
        (lob) => () => {
            const accountSummary = accountData[0];
            const submission = {
                baseData: {
                    productCode: lob,
                    accountHolder: accountSummary,
                    accountNumber: accountSummary.accountNumber,
                    policyAddress: accountSummary.accountContact.primaryAddress,
                    periodStartDate: LocalDateUtil.today()
                }
            };
            AMPSubmissionDraftService.createForAccount(submission, authHeader).then(
                (savedSubmission) => {
                    const { url } = appConfig.quoteAndBuy;
                    const location = `${url}/quote-${getNormalizedLOBName(lob)}`;
                    const params = {
                        quoteID: savedSubmission.quoteID,
                        postalCode: savedSubmission.baseData.policyAddress.postalCode
                    };

                    window.location = generateURL(location, params);
                }
            );
        },
        [accountData, authHeader]
    );

    const getCellAgent = useCallback(
        (rowData) => {
            return (
                
                   
                `${rowData.producerDescription} ${rowData.producerPhoneNumber}`
                    
                
            );
        },
        []
    );

    const getTableOverrides = useCallback(() => {
        return {
            typeColumn: { renderCell: getCellType },
            statusColumn: { renderCell: getCellStatus },
            policyColumn: { renderCell: getCellPolicy },
            locationColumn:{renderCell:getCellLocation},
            effectiveColumn: { renderCell: getCellEffective },
            premiumColumn: { renderCell: getCellPremium },
            fileAClaimColumn: {
                visible: claimCapabilityCheck,
                renderCell: getCellClaim
            },
            agentColumn: {
                renderCell: getCellAgent
            }
        };
    }, [accountData, claimCapabilityCheck]);

    const onFileAClaimQuickLinkClick = useCallback(
        () => () => {
            const { history } = props;
            return history.push({
                pathname: '/fnol-select-policy',
                state: {
                    redirectPath: '/home',
                    claimData: { lossDate: new Date() }
                }
            });
        },
        [props]
    );

    const handleLinkClick = useCallback(
        (event) => {
            const { history } = props;
            return history.push(event.path);
        },
        [props]
    );

    const showBillingSection = useMemo(() => {
        return isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' });
    }, []);

    const getData = useCallback((value) => {
        let res = accountPolicyData
        const filteredAccountPolicyData = _.filter(accountPolicyData, (list) => list.accountNumber === policyAccountDropdown)
        if (_.isEmpty(res)) {
            const temp = {
                rows: accountPolicyData,
                numberOfRows: res.length
            }
            return temp
        }
        if (value?.sorted[0]?.id === "policyColumn") {
            res = filteredAccountPolicyData.sort((a1, b1) => {
                a1 = a1.policyNumber
                b1 = b1.policyNumber
                if (value?.sorted[0]?.desc) {
                    return (b1 > a1) ? 1 : -1
                }
                return (a1 > b1) ? 1 : -1
            })
        }
        else if (value?.sorted[0]?.id === "effectiveColumn") {
            res = filteredAccountPolicyData.sort((a, b) => {
                a = a.effective;
                b = b.effective;
                if (value?.sorted[0]?.desc) {
                    return (LocalDateUtil.toMidnightDate(b) > LocalDateUtil.toMidnightDate(a)) ? 1 : -1;
                }
                return (LocalDateUtil.toMidnightDate(a) > LocalDateUtil.toMidnightDate(b)) ? 1 : -1;
            });
        }else if (value?.sorted[0]?.id === "displayStatus") {
            res = filteredAccountPolicyData.sort((a, b) => {
                a = a.displayStatus;
                b = b.displayStatus;
                if (value?.sorted[0]?.desc) {
                    return (b > a) ? 1 : -1;
                }
                return (a > b) ? 1 : -1;
            });
        }else if (value?.sorted[0]?.id === "lineOfBusinessName") {
            res = filteredAccountPolicyData.sort((a, b) => {
                a = a.lineOfBusinessName;
                b = b.lineOfBusinessName;
                if (value?.sorted[0]?.desc) {
                    return (b > a) ? 1 : -1;
                }
                return (a > b) ? 1 : -1;
            });
        }
        else if (value?.sorted[0]?.id === "locationColumn") {
            res = filteredAccountPolicyData.sort((a1, b1) => {
                a1 = a1.states[0];
                b1 = b1.states[0];
                if (value?.sorted[0]?.desc) {
                    return (b1 > a1) ? 1 : -1;
                }
                return (a1 > b1) ? 1 : -1;
            })
        }
        else if(policyAccountDropdown){
            res = _.filter(accountPolicyData, (list) => list.accountNumber === policyAccountDropdown); 
        }
        else {
            res = _.orderBy(
                filteredAccountPolicyData,
                value.sorted.map(({ id }) => (row) => row[id].toLowerCase()),
                value.sorted?.map(({ desc }) => (desc ? 'desc' : 'asc'))
            );
        }
        const temp = {
            rows: res,
            numberOfRows: res.length
        }
        return temp
    }, [accountPolicyData, policyAccountDropdown])

    if (isLoading) {
        return <LoaderExt loaded={!isLoading} />;
    }

   
    const handleValueChange=(value)=>{
        setPolicyAccountDropdown(value);   
    }

    const override = {
        '@field': {
            phone: {
                labelPosition: 'left'
            }
        },
        myBalanceOverdueAmount: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('due'))
        },
        myBalanceCurrentAmount: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('billed'))
        },
        dueDateContainer: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('due'))
        },
        dueDateLabel: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('billed'))
        },
        payNowButton: {
            visible: firstAccountSummaryDefined
        },
        mediaSidebar: {
            showContact: accountData.length = 1
        },
        policiesTable: {
            onFetchData: getData
        },
        
        setupAutomatedPaymentsLink: {
            onClick: {
                callback: 'handleLinkClick',
                callbackProps: {
                    path: automatedPaymentURL,
                }
            },
            visible: !!automatedPaymentURL && showBillingSection
        },
        getAPAQuote: {
            onClick: onQuoteQuickLinkClick('PersonalAuto'),
            visible: appConfig.quoteAndBuy.ampQuote && firstAccountSummaryDefined
        },
        getAHOQuote: {
            onClick: onQuoteQuickLinkClick('Homeowners'),
            visible: appConfig.quoteAndBuy.ampQuote && firstAccountSummaryDefined
        },
        renewalNotification: {
            visible: showRenewalNotificationShow(accountPolicyData)
        },
        fileAClaimLink: {
            onClick: onFileAClaimQuickLinkClick(),
            visible: claimCapabilityCheck
        },
        tileGroupContainer: {
            visible: showBillingSection
        },
        makeAPaymentLink: {
            visible: showBillingSection
        },
        
        
        ...getTableOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveCallbackMap: {
            handleLinkClick,
            handleValueChange
        },
        resolveComponentMap:{
            AccountDropDownValues: AccountDropDownValues,
        }
    };

    return <MetadataContent uiProps={metadata.pageContent} overrideProps={override} {...resolvers} />;
}

export default withRouter(PoliciesPage);
